exports.accountNumberRegex = (number) => {
  let regex = /^\d{9,18}$/;
  let pass = regex.test(number)
  if (pass) {
    return true
  } else {
    return false
  }
}
exports.ifscRegex = (code) => {
 
  let regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  let pass = regex.test(code)
  if (pass) {
    return true
  } else {
    return false
  }
}
 
exports.checkupiformat = (upi_id) => {
  let regex = /^[\w.-]{2,256}@[a-zA-Z]{2,64}$/;
  if (regex.test(upi_id)) {
    return true
  }
  return false
}

exports.validateMobileNo = (phoneNumber) => {
  var phoneno = /^[+]?[0-9]+$/
  if (phoneNumber?.length === 10 && phoneno?.test(phoneNumber)) {
    return true
  } else {
    return false
  }
}

exports.validateLicenseFormat = (license_number) => {
  // let regex = /^([A-Z]{2}[0-9]{2}[0-9]{7,8}|[A-Z]{2}[0-9]{2}[A-Z][0-9]{4}[0-9]{7})$/;
  const regex = /^[A-Z]{2}[0-9]{2}[A-Z]?[0-9]{4,11}$/i;
  if (regex.test(license_number)) {
    return true
  }
  return false
}

exports.countExpiryStatus = (expiryAlerts = {}) => {
  let expiredCount = 0;
  let expiringSoonCount = 0;

  Object.values(expiryAlerts).forEach((item) => {
    if (!item) return; // skip null/undefined

    if (item.is_expired === true) {
      expiredCount++;
    } else if (item.is_expiring_soon === true) {
      expiringSoonCount++;
    }
  });

  return { expiredCount, expiringSoonCount };
};

